<!-- {{form.getControl(control).value}} -->

<ng-container *ngIf="isNotValid">
	<ng-container *ngIf="formControl.hasError('required')">
		<div class="error"> {{ "ParameterIsRequiredField" | localize : [title] }} </div>
	</ng-container>
	
	<ng-container  *ngIf="formControl.hasError('min')">
		<div class="error"> {{ "ParameterXShouldBeMinimum" | localize : [title, formControl.errors.min.min] }}
		</div>
	</ng-container>

	<ng-container *ngIf="formControl.hasError('max')">
		<div class="error">	{{ "ParameterXShouldBeMaximum" | localize : [title, formControl.errors.max.max] }} </div>
	</ng-container>
	<ng-container class="error" *ngIf="formControl.hasError('pattern')">
		<div class="error"> {{  (patternErrorMessage && patternErrorMessage !== '') ? patternErrorMessage : ("InvalidX" | localize : [title]) }} </div>
	</ng-container>
</ng-container>